import { useContext } from "react";
import { setChatState } from "../fetch/fetch.chat";
import { SubmitContext } from "../context/context.submit";
import { mutate } from "swr";
import { CHAT_URL } from "../fetch/const.routes.ts";
import { ChatStatusType } from "../types/Chat.ts";

export function usePutChatState() {
  const { initSubmit, finishSubmit, loading, setError, error } =
    useContext(SubmitContext);

  const putChatState = async (id: string, state: ChatStatusType) => {
    if (!initSubmit()) return;
    const res = await setChatState(id, state);
    if (!res.ok) {
      setError(String(res.error));
      finishSubmit(false);
      return;
    }
    await Promise.all([
      mutate(`${CHAT_URL}${id}`, res.value),
      mutate(CHAT_URL + "owner", 0),
    ]);
    finishSubmit(false);
  };
  return { putChatState: putChatState, loading: loading, error: error };
}
